import { defineComponent as _defineComponent } from 'vue'
import HeaderComponent from "@/v2/components/HeaderComponent.vue";
  import SidebarComponent from "@/v2/components/SidebarComponent.vue";
  import BottomNavigationComponent from "@/v2/components/BottomNavigationComponent.vue";
  import router from "@/router";
  import { UserRoles } from "@/enums/UserRoles";
  import { EstateType } from "@/enums/EstateType";
  import { EstateAddon } from "@/enums/EstateAddon";
  import { computed, onMounted, ref } from "vue";
  import store from "../../store";
  import {
    homeAndLandPackagesNavigation,
    navigation,
    profilesNavigations,
  } from "@/v2/static/navigation";

  interface WrapperContentStyles {
    background?: string;
    padding?: string;
  }

  interface Props {
    wrapperContentStyles?: WrapperContentStyles;
  }

  
export default /*@__PURE__*/_defineComponent({
  __name: 'Layout',
  props: {
    wrapperContentStyles: { default: () => ({
      background: "#f5f5f7",
      padding: "30px 20px 20px 16px",
    }) }
  },
  setup(__props: any, { expose: __expose }) {
  __expose();

  const props = __props;

  const navList = computed(() => {
    const { fullPath } = router.currentRoute.value;
    const { role } = store.state.user.data;
    const isProfilePages = fullPath.startsWith("/v2/profile");

    if (isProfilePages && role === UserRoles.LANDOWNER) {
      return profilesNavigations.landowner;
    }

    if (isProfilePages && role === UserRoles.SALES_PERSON) {
      return profilesNavigations.salesPerson;
    }

    const selectedEstateId = store.state.user.selectedEstateId;
    const selectedEstate = store.state.user.landownerEstates.find(
      (estate) => estate._id === selectedEstateId
    );

    if (selectedEstate?.type === EstateType.LAND_SUBDIVISION) {
      const landSubdivisionNavigation = navigation.map((item) =>
        item.slug === "project-page" ? { ...item, title: "Project Page" } : item
      );

      if (selectedEstate.addons?.includes(EstateAddon.HL_PACKAGES)) {
        landSubdivisionNavigation.push(homeAndLandPackagesNavigation);
      }

      return landSubdivisionNavigation;
    }

    if (selectedEstate?.type !== EstateType.RESIDENTIAL_COMMUNITY) {
      return navigation.filter((item) => item.slug !== "project-page");
    }

    return navigation;
  });

  const isActiveBurger = ref(false);

  const getEstates = () => {
    return store.dispatch("estate/getEstates", {
      landownerId: store.state.user.data._id,
    });
  };

  onMounted(() => {
    getEstates();
  });

const __returned__ = { props, navList, isActiveBurger, getEstates, HeaderComponent, SidebarComponent, BottomNavigationComponent, get router() { return router }, get UserRoles() { return UserRoles }, get EstateType() { return EstateType }, get EstateAddon() { return EstateAddon }, computed, onMounted, ref, get store() { return store }, get homeAndLandPackagesNavigation() { return homeAndLandPackagesNavigation }, get navigation() { return navigation }, get profilesNavigations() { return profilesNavigations } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})